<template>
  <div class="edit-dialog">
    <base-dialog
      :visible="visible"
      :show-close="false"
      width="calc(100% - 100px)"
      :class="['dialog-wrap', 'edit-dialog-wrap', { 'no-bar': fullScreen }]"
      border-radius="none"
      @open="open"
      @closed="closed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <template v-slot:header>
        <div class="header-wrap">
          <div class="title">
            {{ title }}
          </div>
          <!-- <div class="switch-wrap">
            <el-switch v-model="onlyRequired" @change="changeFormFields"></el-switch>
            <span class="status">{{ !onlyRequired ? "全部" : "仅必填" }}</span>
          </div> -->
          <div class="operation-wrap">
            <base-button v-if="['create'].includes(from)" class="save-btn" type="primary">
              <div @click="submit" class="left">保存</div>
              <dropdown-menu
                @click="clickSubmitDropdown"
                :menu-list="submitMenu"
                margin-top="6"
                trigger="hover"
                placement="bottom-end"
                width="180"
              >
                <div class="right"><i class="el-icon-arrow-down"></i></div>
              </dropdown-menu>
            </base-button>
            <base-button v-else type="primary" @click="submit">保存</base-button>
            <!--<base-button type="primary" @click="submit">保存</base-button>-->
            <base-button @click="closed">取消</base-button>
          </div>
        </div>
      </template>
      <div v-loading="loading" style="height: 100%">
        <div v-ps class="main-wrap">
          <task-form
            v-if="!loading"
            ref="taskForm"
            :from="from === 'milestone' || from === 'risk' ? 'create' : from"
            :project-id="projectId"
            :project-info="projectInfo"
            :only-required="onlyRequired"
            :task-group="taskGroup"
            :parent-task="parent"
            @select-task-type="setTaskType"
            @set-parent="setParent"
            class="form-wrap"
            :cur-user-permission="curUserPermission"
            :is-risk="isRisk"
            :is-milestone="isMilestone"
          ></task-form>
          <ref-info
            ref="refInfo"
            :task-type="taskType"
            class="form-wrap"
            @visible-change="refInfoVisible = $event"
          ></ref-info>
          <!--1. 当前任务深度过深,则不可编辑子任务-->
          <!--2. 当前编辑任务的人,没有编辑子任务权限-->
          <subtask
            v-if="
              !(taskLevel >= 3 || (from === 'edit' && !curUserPermission['UPDATE_SUB_TASK'])) &&
                !(isRisk || isMilestone)
            "
            ref="subtask"
            :project-id="projectId"
            :task-group="taskGroup"
            class="form-wrap"
          ></subtask>
        </div>
      </div>
      <div class="side-nav-wrap" :class="{ hidden: fullScreen }">
        <side-nav ref="sideMenu" :menu-list="sideMenu" @select="selectMenu"></side-nav>
      </div>
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import SideNav from "@/components/Sheet/SideNav"
import TaskForm from "./TaskForm"
import RefInfo from "./RefInfo"
import Subtask from "./Subtask"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import { priorityLevel } from "~/data/project"
import { editDialogType } from "./static"
import { getTask, createTask, updateTask, setTaskMilestone, setTaskRisk } from "@/api/project/task"
import { getProject } from "@/api/project/project"
import ProvideCurProjectUsers from "@/mixins/provideCurProjectUsers"
import ProvideRootDepartment from "@/mixins/provideRootDepartment"
import { getProjectPri, getTaskUserPermission } from "@/utils/checkPermission"
import emitter from "@/mixins/emitter"

export default {
  name: "edit-dialog",
  components: {
    BaseDialog,
    BaseButton,
    SideNav,
    TaskForm,
    RefInfo,
    Subtask,
    DropdownMenu
  },
  mixins: [ProvideCurProjectUsers, ProvideRootDepartment, emitter],
  props: {
    from: String, // ["create", "edit","milestone","risk"]
    visible: Boolean,
    dataId: String,
    taskGroup: Object,
    projectId: String,
    parentTask: Object,
    initData: Object,
    isMilestone: {
      type: Boolean,
      default: false
    },
    isRisk: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let submitMenu = [{ title: "保存并新建下一条", command: "saveAndContinue" }]
    return {
      submitMenu,
      editDialogType,
      priorityLevel,
      loading: false,
      quickCreate: true,
      projectInfo: {},
      taskInfo: null,
      taskType: null,
      onlyRequired: false,
      fullScreen: false,
      refInfoVisible: false, // 由 refInfo 内部控制
      parent: null,
      projectPermission: {
        rolePris: {
          ASSIGNEE: {},
          CREATOR: {},
          PARTICIPANT: {}
        }
      }
    }
  },
  computed: {
    // dialog 标题
    title() {
      if (this.from === "milestone") return "新建 里程碑"
      if (this.from === "risk") return "新建 风险"
      else {
        if (this.isRisk) return this.editDialogType[this.from] + " 风险"
        if (this.isMilestone) return this.editDialogType[this.from] + " 里程碑"
        return this.editDialogType[this.from] + " 任务"
      }
    },
    // 侧边菜单
    sideMenu() {
      let menuList = [{ name: "基本信息", group: "taskForm" }]
      if (this.refInfoVisible) menuList.push({ name: "任务成果", group: "refInfo" })
      if (
        !(
          this.taskLevel >= 3 ||
          (this.from === "edit" && !this.curUserPermission["UPDATE_SUB_TASK"])
        ) &&
        !(this.isRisk || this.isMilestone)
      )
        menuList.push({ name: "子任务", group: "subtask" })
      return menuList
    },
    // 任务层级数
    taskLevel() {
      let level = 1
      if (this.parent) {
        ++level
        if (this.parent?.parentId) ++level
      }
      return level
    },
    curUser() {
      return this.$store.getters.userInfo
    },
    curUserPermission() {
      return getTaskUserPermission(this.projectPermission, this.taskInfo, this.curUser.userId)
    }
  },
  methods: {
    init() {
      if (this.from === "create") {
        this.parent = this.parentTask
        this.$nextTick(() => {
          this.$refs.taskForm.init()
          this.$refs.subtask?.init()
        })
      } else if (this.from === "milestone" || this.from === "risk") {
        this.$nextTick(() => {
          this.$refs.taskForm.init()
        })
      } else if (this.from === "copy") {
        this.$nextTick(() => {
          this.initForCopy()
        })
      } else if (this.from === "edit") {
        this.loading = true
        this.getTask().then(res => {
          this.loading = false
          this.$nextTick(() => {
            this.$refs.taskForm.init(this.taskInfo)
            this.$refs.subtask?.init(this.taskInfo.children)
          })
        })
      }
    },
    open() {
      this.getProject()
      this.init()
      this.refreshCurProjectUsers(this.projectId)
      this.broadcast("rich", "force-update")
    },
    closed() {
      this.$emit("update:visible", false)
      this.$refs.taskForm?.resetData()
      this.taskType = null
    },
    getProject() {
      getProjectPri(this.projectId).then(
        userPermission => (this.projectPermission = userPermission)
      )
      return getProject(this.projectId).then(res => {
        this.projectInfo = res
      })
    },
    getTask() {
      return getTask(this.dataId).then(res => {
        this.parent = res.parentTask
        this.taskInfo = res
      })
    },
    selectMenu(menu) {
      let component = this.$refs[menu.group]
      document.querySelector(".edit-dialog-wrap .main-wrap").scroll({
        top: component.$el.offsetTop,
        behavior: "smooth"
      })
    },
    changeFormFields() {
      //
    },
    setTaskType(taskType) {
      this.taskType = taskType
      this.$nextTick(() => this.$refs.refInfo.init())
    },
    setParent(parent) {
      this.parent = parent
    },
    async submit({ continueCreate } = {}) {
      let { result, form } = await this.$refs.taskForm.output()
      if (!result) return
      let subtask
      if (this.$refs.subtask) {
        subtask = this.$refs.subtask.output()
        if (!subtask.result) return
      }
      let params = { projectId: this.projectId, children: subtask?.data }
      this.parent && Object.assign(params, { parentId: this.parent.id })
      Object.assign(params, form)
      this.loading = true
      let res
      try {
        switch (this.from) {
          case "copy":
            res = await createTask(params)
            break
          case "create":
            res = await createTask(params)
            if (params.taskMould === "risk") {
              await setTaskRisk(
                res.id,
                true,
                params?.riskLevel || 0,
                params?.copingPlan || "",
                params?.attachmentIds || [],
                params?.description || ""
              )
              this.$message.success("风险创建成功！")
            } else if (params.taskMould === "milestone") {
              await setTaskMilestone(res.id, true)
              this.$message.success("里程碑创建成功！")
            } else if (params.taskMould === "task") {
              this.$message.success("任务创建成功！")
            }
            break
          case "edit":
            res = await updateTask(params, this.taskInfo.id)
            if (params.taskMould === "risk") {
              await setTaskRisk(
                res.id,
                true,
                params?.riskLevel || 0,
                params?.copingPlan || "",
                params?.attachmentIds || [],
                params?.description || ""
              )
              this.$message.success("风险更新成功！")
            } else if (params.taskMould === "milestone") {
              this.$message.success("里程碑更新成功！")
            } else if (params.taskMould === "task") {
              this.$message.success("任务更新成功！")
            }
            break
          case "milestone":
            // 新建里程碑自动将task设为里程碑
            res = await createTask(params)
            await setTaskMilestone(res.id, true)
            this.$message.success("里程碑创建成功！")
            break
          case "risk":
            // 新建风险自动将task设为风险
            res = await createTask(params)
            await setTaskRisk(
              res.id,
              true,
              params?.riskLevel || 0,
              params?.copingPlan || "",
              params?.attachmentIds || [],
              params?.description || ""
            )
            this.$message.success("风险创建成功！")
            break
          default:
        }
      } catch (res) {
        this.loading = false
        return
      }
      this.loading = false
      this.$emit("after-submit", this.from)
      if (continueCreate) {
        this.$nextTick(() => this.initForCreate())
        return
      }
      this.closed()
    },
    // 点击保存下拉框里的菜单项
    clickSubmitDropdown(command) {
      switch (command) {
        case "saveAndContinue": {
          this.submit({ continueCreate: true })
          break
        }
      }
    },
    initForCreate() {
      this.$refs.taskForm.resetData()
      this.init()
    },
    initForCopy() {
      this.taskInfo = this.initData || {}
      this.parent = this.taskInfo.parentTask
      this.$refs.taskForm.init(this.taskInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  &::-webkit-scrollbar-track-piece {
    background: #cccccc;
  }
  &::-webkit-scrollbar {
    height: 14px;
  }
  &::-webkit-scrollbar-thumb {
    background: #9e9e9e;
    border-radius: 20px;
  }
  ::v-deep .el-dialog {
    min-width: 1200px;
    height: calc(100vh - 70px);
    color: $color-font-first;
    .header {
      padding: 0 !important;
    }
    .header-wrap {
      flex: auto;
      display: flex;
      height: 100%;
      align-items: center;
      padding: 0 40px;
      .title {
        @include ellipsis;
        margin-right: auto;
        font-size: $font-size-title-first;
      }
      .switch-wrap {
        min-width: 120px;
        text-align: right;
        .status {
          text-align: left;
          display: inline-block;
          width: 60px;
          margin-left: 6px;
          font-size: 14px;
        }
      }
      .operation-wrap {
        display: flex;
        .save-btn {
          position: relative;
          padding: 0;
          overflow: hidden;
          background: none;
          span {
            display: flex;
          }
          .left {
            padding: 6px 10px 6px 15px;
          }
          .right {
            padding: 6px 10px 6px 7px;
          }
          .left,
          .right {
            background: $color-main;
            &:hover {
              background: rgba(25, 137, 250, 0.7) !important;
            }
          }
        }
      }
    }
    .el-dialog__body {
      padding: 0;
      margin: 0;
      position: relative;
      height: 100%;
    }
    .main-wrap {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      position: relative;
      z-index: 10;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 15px 0;
      .form-wrap {
        width: 84%;
        margin-bottom: 32px;
        padding-left: 62px;
        box-sizing: border-box;
      }
    }
    .side-nav-wrap {
      position: absolute;
      width: 15%;
      margin-right: 1%;
      top: 0;
      bottom: 0;
      right: 0;
      &.hidden {
        visibility: hidden;
      }
    }
  }
}
</style>
